import { Injectable } from '@angular/core';
import { Question } from '../../models/Audits/question';

@Injectable({
  providedIn: 'root'
})
export class AuditGuidService {

  constructor() { }


  public setGUIDs(questions: Question[]) {
    for (var i: number = 0; i < questions.length; i++) {
      questions[i].GUID = crypto.randomUUID();
    }


    questions = questions.sort(
      (a, b) => a.Seq - b.Seq
    );

    for (var i: number = 0; i < questions.length; i++) {
      if (i == 0) {
        questions[i].PrevQ = '-1';
      } else {
        questions[i].PrevQ = questions[i - 1].GUID;
      }
      if (i == questions.length - 1) {
        questions[i].NextQ = '-1';
      } else {
        questions[i].NextQ = questions[i + 1].GUID;
      }
      /*if (questions[i].IsRepeatEnd) {
        var RestartID = questions[i].RepeatStartID;
        questions.forEach((element) => {
          if (
            element.QuestionID >= RestartID &&
            element.QuestionID < questions[i].QuestionID
          ) {
            questions[i].RepeatQuestions.push(element);
          }
        });
      }*/
    }

  }
  public setBranchGUIDs(questions: Question[], preserveExisting: boolean = false) {
    const questionsById = new Map<number, Question>();
    questions.forEach(question => {
      if (!questionsById.has(question.QuestionID)) {
        questionsById.set(question.QuestionID, question);
      }
    });
    const currentGUIDs = new Set(questions.map(question => question.GUID));

    questions.forEach(q => {
      if (q.IsBranching) {
        q.QuestionAnswers.forEach(a => {
          if (
            preserveExisting &&
            (a.BranchGUIDs ?? []).every(guid => currentGUIDs.has(guid)) &&
            (a.BranchGUIDs?.length ?? 0) > 0
          ) {
            return;
          }
          a.BranchGUIDs = (a.BranchAnswerQuestionIDs ?? [])
            .map(questionId => questionsById.get(questionId)?.GUID)
            .filter((guid): guid is string => !!guid);
        })
      }
    })
  }
  public applyBranchSelection(branchingQuestion: Question, questions: Question[]): string | null {
    const selectedAnswer = branchingQuestion.QuestionAnswers.find(
      answer => answer.QuestionAnswerID == branchingQuestion.CompletionInfo.Answer
    );
    const allBranchGUIDs = new Set(
      branchingQuestion.QuestionAnswers.flatMap(answer => answer.BranchGUIDs ?? [])
    );
    const selectedBranchGUIDs = new Set(selectedAnswer?.BranchGUIDs ?? []);

    questions.forEach(question => {
      if (allBranchGUIDs.has(question.GUID)) {
        question.BranchedOut = !selectedBranchGUIDs.has(question.GUID);
      }
    });

    return selectedAnswer?.BranchGUIDs?.[0] ?? null;
  }
  public orderFlattenedQuestions(questions: Question[]): Question[] {
    var returnList: Question[] = [];
    var firstQuestion = questions.find((e) => {
      return e.PrevQ == '-1';
    })!;
    returnList.push(firstQuestion);
    var nextQuestion = firstQuestion.NextQ;
    for (let i = 1; i < questions.length; i++) {
      var currentQ: Question = this.getFlattenedQuestionByGUID(nextQuestion, questions);
      if (currentQ != undefined && nextQuestion != '-1') {
        returnList.push(currentQ);
        nextQuestion = currentQ.NextQ;
      }
    }
    questions = returnList;
    return questions;
  }
  public getFlattenedQuestionByGUID(GUID: string, questions: Question[]): Question {
    var selectedQuestion = questions.find((e) => {
      return e.GUID == GUID;
    })!;
    //this.checkAutoCloseSidePanel();
    return selectedQuestion;
  }
}
